<template>
<w-map-popup title="이벤트 리스트">
  <el-radio-group v-model="eventType" v-if="!isEmptyPredictList" class="ordinary mr-b5" style="margin-top: 0px;">
    <el-radio-button label="status">이벤트 현황</el-radio-button>
    <el-radio-button label="predict">사전 예측 이벤트</el-radio-button>
  </el-radio-group>
  <div style="width:100%;height:100%;">
    <div :class="$style.info">
      <div :class="$style['info-content']" v-if="visibleInfo(INFO_TYPE.NAME)">
        <label>대상명 : </label>
        <label>{{ name() }}</label>
      </div>
      <div :class="$style['info-content']" v-if="visibleInfo(INFO_TYPE.SUB_MAP)">
        <label>하위맵 : </label>
        <label>{{ name() }}</label>
      </div>
      <div :class="$style['info-content']" v-if="visibleInfo(INFO_TYPE.IP)">
        <label>IP : </label>
        <label>{{ ip() }}</label>
      </div>
      <div :class="$style['info-content']" v-if="visibleInfo(INFO_TYPE.IF)">
        <label>출발지 : </label>
        <label>{{ terminal('src') }}</label>
      </div>
      <div :class="$style['info-content']" v-if="visibleInfo(INFO_TYPE.IF)">
        <label>목적지 : </label>
        <label>{{ terminal('dst') }}</label>
      </div>
      <div :class="$style['info-content']">
        <label>이벤트 수 : </label>
        <label>{{ (eventType === MapConst.EVENT_TYPE.STATUS) ? statusCnt() : predictCnt() }} 개</label>
      </div>
    </div>
    <div :class="$style.table">
      <el-table
        :data="eventType === MapConst.EVENT_TYPE.STATUS ? statusList : predictList"
        border
        height="100%"
        style="width: 100%"
        class="popup"
        v-loading="isLoading"
        >
        <el-table-column
          v-for="column in columns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
          :width="column.width"
          :align="column.align"
          >
          <template slot-scope="scope">
            <w-eventlevel-cell v-if="column.scopedSlot === 'eventlevel-slot'" mini :eventlevel-id="scope.row.eventlevelId"/>
            <span v-else-if="column.scopedSlot === 'event-message-slot'">
              <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
                동적
              </div>
              <a href="#" @click="clickEventMessage(scope.row)" :class="$style['click-item']">{{scope.row.eventMessage}}</a>
            </span>
            <a href="#"  v-else-if="column.scopedSlot === 'obj-name-slot'" @click="onObjNameClick(scope.row, $event)" :class="$style['click-item']">{{scope.row.objName}}</a>
            <span v-else-if="column.scopedSlot === 'check-datetime-slot'">{{getDateFormatter(scope.row[scope.column.property])}}</span>
            <span v-else-if="column.scopedSlot === 'default'">{{scope.row[scope.column.property]}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</w-map-popup>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import axios from 'axios';

import MapAPI from '@/api/topologymap/common';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';

import Base from '@/mixins/topologymap/base';

import WEventlevelCell from '@/components/table/EventlevelCell';

import MapConst from '@/constants/topologymap';

import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { openFaultAnalysisPopup } from '@/utils/event';

import WMapPopup from '@/views/topologymap/components/MapPopup';
import { Q, MapInfo } from '@/views/topologymap/js/maps';

const INFO_TYPE = {
  NAME: 'name',
  SUB_MAP: 'sub_map',
  IP: 'ip',
  IF: 'interface',
};

export default {
  name: 'WEventListWindow',
  components: {
    WEventlevelCell,
    WMapPopup,
  },
  mixins: [Base],
  data() {
    return {
      INFO_TYPE,
      MapConst,
      eventType: MapConst.EVENT_TYPE.STATUS,
      /**
       * 선택 된 오브젝트 모델
       * @type {Q.Node}
       */
      target: null,
      /**
       * 테이블 로딩 플래그
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * 현황 이벤트 리스트 데이터
       * @type {Array}
       */
      statusList: [],
      /**
       * 사전 예측 이벤트 리스트 데이터
       * @type {Array}
       */
      predictList: [],
      /**
       * 사전 예측 이벤트의 null 여부 확인 플래그
       * @type {Boolean}
       */
      isEmptyPredictList: true,
      /**
       * 팝업 속성
       */
      config: {
        type: MapConst.POPUP_TYPE.WINDOW,
        width: 800,
        height: 400,
        clickToClose: false,
        scrollable: true,
        resizable: true,
        draggable: '.popup-header',
      },
      events: {
        shown(evt) {
          const thisPopup = evt.popup;
          thisPopup.currentTarget = evt.data.target;
        },
        hidden(evt) {
          const thisPopup = evt.popup;
          thisPopup.statusList = [];
          thisPopup.predictList = [];
          thisPopup.eventType = MapConst.EVENT_TYPE.STATUS;
        },
      },
      /**
       * 컬럼
       * @type {Object}
       */
      eventListColumn: {
        eventlevelName: {
          prop: 'eventlevelName',
          label: '등급',
          width: 80,
          columnKey: 'eventlevelId',
          className: 'eventlevel',
          scopedSlot: 'eventlevel-slot',
          resizable: false,
        },
        objName: {
          prop: 'objName',
          label: '대상',
          width: 120,
          scopedSlot: 'obj-name-slot',
          resizable: false,
        },
        ipaddress: {
          prop: 'ipaddress',
          label: 'IP 주소',
          width: 120,
          scopedSlot: 'default',
          resizable: false,
        },
        eventMessage: {
          prop: 'eventMessage',
          label: '장애메시지',
          scopedSlot: 'event-message-slot',
          resizable: false,
        },
        statusCheckDatetime: {
          prop: 'checkDatetime',
          label: '발생시각',
          width: 150,
          scopedSlot: 'check-datetime-slot',
          resizable: false,
        },
        predictCheckDatetime: {
          prop: 'checkDatetime',
          label: '예상발생시각',
          width: 150,
          scopedSlot: 'check-datetime-slot',
          resizable: false,
        },
      },
    };
  },
  computed: {
    currentTarget: {
      get() {
        return this.target;
      },
      set(value) {
        this.target = value;
        this.loadData();
      },
    },
    visibleInfo() {
      return (type) => {
        let visible = false;
        switch (type) {
          case INFO_TYPE.NAME:
            if (this.currentTarget instanceof Q.ManagedObjectModel || this.currentTarget instanceof Q.Custom1Model) {
              visible = true;
            }
            break;
          case INFO_TYPE.SUB_MAP:
            if (this.currentTarget instanceof Q.SubTopologymapModel) {
              visible = true;
            }
            break;
          case INFO_TYPE.IP:
            if ((this.currentTarget instanceof Q.ManagedObjectModel && !this.isService) || this.currentTarget instanceof Q.Custom1Model) {
              visible = true;
            }
            break;
          case INFO_TYPE.IF:
            if (this.currentTarget instanceof Q.LanModel) {
              visible = true;
            }
            break;
          default:
        }

        return visible;
      };
    },
    /**
     * 선택 된 모델에 따른 컬럼 반환
     * @author KangBonghun(toto1323)
     * @return {Array} 컬럼
     */
    columns() {
      const { eventlevelName, objName, ipaddress, eventMessage, statusCheckDatetime, predictCheckDatetime } = this.eventListColumn;

      let columns = [];
      if (this.currentTarget instanceof Q.ManagedObjectModel) {
        if (this.isService) {
          columns = [
            eventlevelName,
            eventMessage,
            (this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime,
          ];
        } else {
          columns = [
            eventlevelName,
            ipaddress,
            eventMessage,
            (this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime,
          ];
        }
      } else if (this.currentTarget instanceof Q.LanModel) {
        columns = [
          eventlevelName,
          objName,
          ipaddress,
          eventMessage,
          (this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime,
        ];
      } else if (this.currentTarget instanceof Q.SubTopologymapModel) {
        columns = [
          eventlevelName,
          objName,
          ipaddress,
          eventMessage,
          (this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime,
        ];
      } else if (this.currentTarget instanceof Q.Custom1Model) {
        columns = [
          eventlevelName,
          objName,
          ipaddress,
          eventMessage,
          (this.eventType === MapConst.EVENT_TYPE.STATUS) ? statusCheckDatetime : predictCheckDatetime,
        ];
      }

      return columns;
    },
    isService() {
      return this.currentTarget.get('objDefineId') === 'SERVICE';
    },
  },
  methods: {
    /**
     * 대상 이름 반환
     * @author KangBonghun(toto1323)
     * @return {String} 대상 이름
     */
    name() {
      if (this.currentTarget) {
        if (this.currentTarget instanceof Q.SubTopologymapModel) {
          return this.currentTarget.get('mapName');
        }
        return this.currentTarget.get('objName');
      }
      return '-';
    },
    /**
     * 대상 아이피 반환
     * @author KangBonghun(toto1323)
     * @return {String} 대상 아이피
     */
    ip() {
      if (this.currentTarget) {
        return this.currentTarget.get('model').ipaddress;
      }
      return '-';
    },
    /**
     * 회선 목적지 / 출발지 반환
     * @author KangBonghun(toto1323)
     * @param  {String} type 목적지인지 출발지인지 구분. src=출발지, dst=목적지
     * @return {String}      목적지/출발지 명 반환
     */
    terminal(type) {
      if (this.currentTarget) {
        const model = this.currentTarget.get('model');
        return `${model[`${type}ObjName`] || '-'} (${model[`${type}Ipaddress`] || '-'})`;
      }
      return '-';
    },
    /**
     * 현황 이벤트 개수 반환
     * @author KangBonghun(toto1323)
     * @return {String} 이벤트 개수
     */
    statusCnt() {
      return this.statusList.length;
    },
    /**
     * 사전 예측 이벤트 개수 반환
     * @author KangBonghun(toto1323)
     * @return {String} 이벤트 개수
     */
    predictCnt() {
      return this.predictList.length;
    },
    /**
     * 이벤트 리스트 데이터 로드
     * @author KangBonghun(toto1323)
     */
    loadData() {
      this.isLoading = true;
      const model = this.currentTarget.get('model');
      const { objId, elementId, srcObjId, dstObjId } = model;

      // 현황 이벤트 파라미터
      let objectType = '';
      if (this.currentTarget instanceof Q.ManagedObjectModel) {
        objectType = 'ManagedObjectModel';
      } else if (this.currentTarget instanceof Q.LanModel) {
        objectType = 'LanModel';
      } else if (this.currentTarget instanceof Q.SubTopologymapModel) {
        objectType = 'SubTopologymapModel';
      } else if (this.currentTarget instanceof Q.Custom1Model) {
        objectType = 'Custom1Model';
      }

      if (this.currentTarget instanceof Q.LanModel) {
        axios.all([
          MapAPI.getElementEventList(elementId, objectType),
          EventPredictSettingsAPI.getPredictEventHist({ objId: srcObjId }),
          EventPredictSettingsAPI.getPredictEventHist({ objId: dstObjId }),
        ]).then(axios.spread((statusRes, predictSrcRes, predictDstRes) => {
          if (!isEmpty(statusRes.data) && statusRes.data.success) {
            this.statusList = statusRes.data.data;
          }
          let tempPredictList = [];
          if (!isEmpty(predictSrcRes.data) && predictSrcRes.data.success) {
            tempPredictList = tempPredictList.concat(predictSrcRes.data.data);
          }
          if (!isEmpty(predictDstRes.data) && predictDstRes.data.success) {
            tempPredictList = tempPredictList.concat(predictDstRes.data.data);
          }
          this.predictList = tempPredictList;
          this.isEmptyPredictList = (this.predictList.length === 0);
          this.isLoading = false;
        }));
      } else {
        // 사전예측 이벤트 파라미터
        const params = {
          objId,
        };

        axios.all([
          MapAPI.getElementEventList(elementId, objectType),
          EventPredictSettingsAPI.getPredictEventHist(params),
        ]).then(axios.spread((statusRes, predictRes) => {
          if (!isEmpty(statusRes.data) && statusRes.data.success) {
            this.statusList = statusRes.data.data;
          }
          if (!isEmpty(predictRes.data) && predictRes.data.success) {
            this.predictList = predictRes.data.data;
            this.isEmptyPredictList = (this.predictList.length === 0);
          }
          this.isLoading = false;
        }));
      }
    },
    /**
     * 발생시각 컬럼 포멧
     * @author KangBonghun(toto1323)
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value, 'YYYY-MM-DD HH:mm:ss');
      }
      return EMPTY_TEXT;
    },
    /**
     * 장애메시지 클릭시 장애 연계
     * @author KangBonghun(toto1323)
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    clickEventMessage(row) {
      openFaultAnalysisPopup(row.seqNumber);
    },
    /**
     * 대상 이름 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} rowData [description]
     * @param  {[type]} event   [description]
     * @return {[type]}         [description]
     */
    onObjNameClick(rowData, evt) {
      const objId = rowData.objId;
      MapInfo.getInstance(this).getToolbar(MapConst.VIEW_MODE.MONITORING).showMapListMenu(evt, {
        objId,
      });
    },
  },
};
</script>

<style module>
.click-item {
  color: #1c53ca !important;
}

.click-item:hover {
  text-decoration: underline;
  cursor: pointer !important;
}

.info {
  height: 50px;
  width: 100%;
  border-color: #4b7cd0 #6b85aa #667994 #6b85aa;
  border-width: 1px;
  border-style: solid;
  box-shadow: inset 0 2px 0 #4b7cd0,0 1px 1px #d5d5de!important;
  border-radius: 4px;
  padding: 17px 15px 15px 15px;
  line-height: 20px;
}

.table {
  width: 100%;
  height: calc(100% - 60px);
  margin-top: 10px;
}

.info-content {
  display: inline-block;
  margin-right: 30px;
}

.info-content > label:first-child {
  font-weight: 500;
  margin-right: 15px;
  background-image: url(../../../../assets/img/topologymap/dot.png);
  background-repeat: no-repeat;
  background-position: left;
  padding-left: 9px;
}
/* .eventlevel-cell {
  border-left: 3px solid;
  height: 100%;
  width: 100%;
} */
</style>



// WEBPACK FOOTER //
// src/views/topologymap/components/monitoring/EventListWindow.vue